import React from 'react';
import PropTypes from 'prop-types';
import { TableRow } from '@mui/material';
import { DynamicField } from '@totalsoft/rocket-ui';
import debounce from 'debounce-promise';
import { getDynamicFieldControlType } from 'utils/functions';
import { PaymentPlanTableCell } from './OfferPaymentPlanStyles';

const areEqual = propsExcluded => (prevProps, nextProps) => {
  return Object.keys(prevProps)
    .filter(x => !propsExcluded.includes(x))
    .every(key => {
      return prevProps[key] === nextProps[key];
    });
};

export const OfferPaymentPlanParamsRowComponent = React.memo(
  ({
    scheduleCellParamColumns,
    rowData,
    rowIdx,
    handleRowPropertyChange,
    handlePropertyParamChange,
    fixedTableColumns,
    isEditable,
    getDynamicInputParams
  }) => {
    return (
      <>
        {rowData && (
          <TableRow key={rowIdx + rowData.MonthNo}>
            {fixedTableColumns?.map(m => {
              return (
                <PaymentPlanTableCell key={rowIdx + '_' + m.cellParamId}>
                  <DynamicField
                    id={'offerPaymentPlanParamsCard_' + rowIdx + '_' + m.cellParamName}
                    controlType={getDynamicFieldControlType(m.controlType)}
                    isClearable={false}
                    onChange={debounce(value => handleRowPropertyChange(rowIdx, m.cellParamName, value), 200)}
                    value={rowData[m.cellParamName]}
                    disabled={m.readOnly || !isEditable}
                  />
                </PaymentPlanTableCell>
              );
            })}
            {scheduleCellParamColumns?.map(m => {
              return (
                <PaymentPlanTableCell key={rowIdx + '_' + m.cellParamId}>
                  <DynamicField
                    id={'offerPaymentPlanParamsCard_' + rowIdx + '_' + m.cellParamName}
                    controlType={getDynamicFieldControlType(getDynamicInputParams(m.controlType).controlType)}
                    inputProps={getDynamicInputParams(m.controlType).inputProps}
                    isClearable={false}
                    onChange={debounce(value => handlePropertyParamChange(rowIdx, m.cellParamName, value), 200)}
                    disabled={!isEditable}
                    value={rowData[m.cellParamName]}
                  />
                </PaymentPlanTableCell>
              );
            })}
          </TableRow>
        )}
      </>
    );
  },
  areEqual(['fixedTableColumnsClasses'])
);

OfferPaymentPlanParamsRowComponent.displayName = 'OfferPaymentPlanParamsRowComponent';

OfferPaymentPlanParamsRowComponent.propTypes = {
  scheduleCellParamColumns: PropTypes.array.isRequired,
  rowData: PropTypes.object.isRequired,
  rowIdx: PropTypes.number.isRequired,
  handleRowPropertyChange: PropTypes.func.isRequired,
  handlePropertyParamChange: PropTypes.func.isRequired,
  fixedTableColumns: PropTypes.array.isRequired,
  isEditable: PropTypes.bool,
  getDynamicInputParams: PropTypes.func.isRequired
};

export default OfferPaymentPlanParamsRowComponent;
